import {
	CommandRoot,
	CommandDialog,
	CommandInput,
	CommandList,
	CommandEmpty,
	CommandGroup,
	CommandItem,
	CommandShortcut,
	CommandSeparator
} from './Command';

export const Command = {
	Root: CommandRoot,
	Dialog: CommandDialog,
	Input: CommandInput,
	List: CommandList,
	Empty: CommandEmpty,
	Group: CommandGroup,
	Item: CommandItem,
	Shortcut: CommandShortcut,
	Separator: CommandSeparator
};
